import React, { useState, useEffect } from "react";
import PublicLayout from "../../components/layout/PublicLayout";
import { ContactoForm } from "../../components/shared";
import { generateClient } from "aws-amplify/data";
import { fetchAuthSession } from "aws-amplify/auth";
// import { invoke } from "aws-amplify/api";

const client = generateClient();

async function pickAuthMode() {
  try {
    const s = await fetchAuthSession();
    return s.tokens ? "userPool" : "identityPool";
  } catch {
    return "identityPool";
  }
}

const Contacto = () => {
  const [contactInfo, setContactInfo] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchContactInfo = async () => {
      setLoading(true);
      try {
        const authMode = await pickAuthMode();
        const { data: items } = await client.models.ContactInfo.list({
          authMode,
        });
        if (items.length > 0) {
          setContactInfo(items[0]);
        }
      } catch (error) {
        console.error("Error al obtener información de contacto:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchContactInfo();
  }, []);

  const handleContactFormSubmit = async (formData) => {
    try {
      // await invoke("myLambdaFunction", { body: formData });
      alert("Gracias por contactarnos. Te responderemos pronto.");
    } catch (error) {
      console.error("Error al enviar el formulario:", error);
      alert("Error al enviar el formulario. Inténtalo de nuevo.");
    }
  };

  if (loading || !contactInfo)
    return <div>Cargando información...</div>;

  return (
    <PublicLayout>
      <div className="min-h-screen bg-gray-300 p-6">
        <div className="mb-6 rounded-lg bg-gray-800 py-3 text-center text-xl font-semibold text-white">
          Contacto
        </div>
        <div className="flex flex-col lg:flex-row">
          <div className="w-full lg:w-1/2 p-4">
            <ContactoForm
              contactInfo={contactInfo}
              onSubmit={handleContactFormSubmit}
            />
          </div>

          <div className="w-full lg:w-1/2 p-4">
            <div className="rounded-lg bg-white shadow overflow-hidden">
              <iframe
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d313625.6132058854!2d-99.45543766475465!3d19.390467859851373!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x85ce0026db097507%3A0x54061076265ee841!2sCiudad%20de%20M%C3%A9xico%2C%20CDMX!5e1!3m2!1ses-419!2smx!4v1756796983757!5m2!1ses-419!2smx"
                title="Mapa de ubicación"
                className="w-full border-0 h-[360px] lg:h-[595px]"
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </PublicLayout>
  );
};

export default Contacto;
